import gayatry from "../../../assets/gayatry.jpg";
import dillo from "../../../assets/dillo.jpg";
import finanzas from "../../../assets/finanzas-app.png";
import iaNews from "../../../assets/ia-news.png";

export const projects = [
  {
    title: "Dillostores landing page",
    href: "https://dillostores.com/",
    img: dillo,
  },
  {
    title: "Finanzas app",
    href: "https://finanzas-arg.vercel.app/",
    img: finanzas,
  },
  {
    title: "IA News",
    href: "https://ia-news.vercel.app/",
    img: iaNews,
  },
  {
    title: "Gayatry (e-commerce)",
    href: "https://gayatry.shop/",
    img: gayatry,
  },
];
